import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { EntityMemberJSON } from "_shared/entity-members/entity-member-schema";
import { FeeScheduleCategoryType } from "_shared/fee-schedules/categories/types/fee-schedule-category-type";
import { FeeScheduleCategoryMaskedCurrency } from "work/masked-fields";

export type FeeScheduleCategoryCommandPayload = {
  name?: string;
  description?: string;
  type?: FeeScheduleCategoryType;
  feeRate?: number;
  feeCurrency?: string;
  feeUnit?: string;
  teamMember?: EntityMemberJSON | null;
  id?: string;
  version?: number;
};
export default class FeeScheduleCategoryCommand {
  id?: string;
  name?: string;
  description?: string;
  type?: FeeScheduleCategoryType;
  feeRate?: number;
  feeCurrency?: string;
  feeUnit?: string;
  teamMember?: EntityMemberJSON | null;
  version?: number;

  public get payload(): FeeScheduleCategoryCommandPayload {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      feeRate: this.feeRate,
      feeCurrency: this.feeCurrency,
      feeUnit: this.feeUnit,
      teamMember: this.teamMember,
      version: this.version,
    };
  }

  constructor(category: FeeScheduleCategory | FeeScheduleCategoryMaskedCurrency) {
    if (!category.name) throw new Error("Fee Schedule Category name is required");
    this.id = category.id?.value;
    this.version = category instanceof FeeScheduleCategory ? category.version : undefined;
    this.name = category.name.value;
    this.description = category.description?.value;
    this.type = category.type;
    if (category instanceof FeeScheduleCategoryMaskedCurrency) {
      return;
    }
    this.feeRate = category.fee?.rate?.amount;
    this.feeCurrency = category.fee?.rate?.currency;
    this.feeUnit = category.fee?.unit ?? undefined;
    if (!category.teamMemberIsMasked) this.teamMember = category.teamMember?.toJSON() ?? null;
  }
}
